@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import id.neotica.neotica.components.layouts.MarkdownLayout as _id_neotica_neotica_components_layouts_MarkdownLayout
import id.neotica.neotica.components.layouts.NeoPageLayout as _id_neotica_neotica_components_layouts_NeoPageLayout
import id.neotica.neotica.pages.AboutLolPage as _id_neotica_neotica_pages_AboutLolPage
import id.neotica.neotica.pages.AboutPage as _id_neotica_neotica_pages_AboutPage
import id.neotica.neotica.pages.ContactPage as _id_neotica_neotica_pages_ContactPage
import id.neotica.neotica.pages.HomePage as _id_neotica_neotica_pages_HomePage
import id.neotica.neotica.pages.KtorReferencesPage as _id_neotica_neotica_pages_KtorReferencesPage
import id.neotica.neotica.pages.alexandria.AlexandriaPage as _id_neotica_neotica_pages_alexandria_AlexandriaPage
import id.neotica.neotica.pages.android.AndroidPage as _id_neotica_neotica_pages_android_AndroidPage
import id.neotica.neotica.pages.archive.HomeArchive2025Page as _id_neotica_neotica_pages_archive_HomeArchive2025Page
import id.neotica.neotica.pages.auth.AuthPage as _id_neotica_neotica_pages_auth_AuthPage
import id.neotica.neotica.pages.auth.ContentPage as _id_neotica_neotica_pages_auth_ContentPage
import id.neotica.neotica.pages.holomarket.HoloMarketAppDetailPage as _id_neotica_neotica_pages_holomarket_HoloMarketAppDetailPage
import id.neotica.neotica.pages.holomarket.HoloMarketAppsPage as _id_neotica_neotica_pages_holomarket_HoloMarketAppsPage
import id.neotica.neotica.pages.holomarket.HoloMarketLandingPage as _id_neotica_neotica_pages_holomarket_HoloMarketLandingPage
import id.neotica.neotica.pages.holomarket.HoloMarketProductDetailPage as _id_neotica_neotica_pages_holomarket_HoloMarketProductDetailPage
import id.neotica.neotica.pages.holomarket.HoloMarketUploadPage as _id_neotica_neotica_pages_holomarket_HoloMarketUploadPage
import id.neotica.neotica.pages.legal.PrivacyPolicyPage as _id_neotica_neotica_pages_legal_PrivacyPolicyPage
import id.neotica.neotica.pages.legal.TermsOfServicePage as _id_neotica_neotica_pages_legal_TermsOfServicePage
import id.neotica.neotica.pages.member.MemberDetailPage as _id_neotica_neotica_pages_member_MemberDetailPage
import id.neotica.neotica.pages.member.MemberPage as _id_neotica_neotica_pages_member_MemberPage
import id.neotica.neotica.pages.orpheum.OrpheumAlbumPage as _id_neotica_neotica_pages_orpheum_OrpheumAlbumPage
import id.neotica.neotica.pages.orpheum.OrpheumPage as _id_neotica_neotica_pages_orpheum_OrpheumPage
import id.neotica.neotica.pages.photobooth.PhotoboothPage as _id_neotica_neotica_pages_photobooth_PhotoboothPage
import id.neotica.neotica.pages.profile.RyoMartinPage as _id_neotica_neotica_pages_profile_RyoMartinPage
import id.neotica.neotica.pages.projects.ProjectsPage as _id_neotica_neotica_pages_projects_ProjectsPage

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Neotica"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "id.neotica.neotica.components.layouts.MarkdownLayout",
            parentLayoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _id_neotica_neotica_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "id.neotica.neotica.components.layouts.NeoPageLayout",
        ) { pageCtx, pageMethod -> 
            _id_neotica_neotica_components_layouts_NeoPageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_AboutPage()
        }
        ctx.router.register(
            "/about-lol",
            layoutId = "id.neotica.neotica.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.initAboutLolPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_AboutLolPage()
        }
        ctx.router.register(
            "/alexandria/",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.alexandria.initAlexandriaPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_alexandria_AlexandriaPage()
        }
        ctx.router.register(
            "/android/",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.android.initAndroidPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_android_AndroidPage()
        }
        ctx.router.register(
            "/archive/2025",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.archive.initHomeArchive2025(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_archive_HomeArchive2025Page()
        }
        ctx.router.register(
            "/auth/",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.auth.initAuthPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_auth_AuthPage()
        }
        ctx.router.register(
            "/auth/content",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.auth.initContentPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_auth_ContentPage()
        }
        ctx.router.register(
            "/contact",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.initContactPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_ContactPage()
        }
        ctx.router.register(
            "/holomarket",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.holomarket.initHoloMarketLanding(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_holomarket_HoloMarketLandingPage()
        }
        ctx.router.register(
            "/holomarket/app/{package}",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.holomarket.initAppDetailPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_holomarket_HoloMarketAppDetailPage()
        }
        ctx.router.register(
            "/holomarket/apps",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.holomarket.initAppsPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_holomarket_HoloMarketAppsPage()
        }
        ctx.router.register(
            "/holomarket/product-detail",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.holomarket.initProductDetailPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_holomarket_HoloMarketProductDetailPage()
        }
        ctx.router.register(
            "/holomarket/upload",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.holomarket.initAppSubmissionPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_holomarket_HoloMarketUploadPage()
        }
        ctx.router.register(
            "/legal/privacy-policy",
            layoutId = "id.neotica.neotica.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.legal.initPrivacyPolicyPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_legal_PrivacyPolicyPage()
        }
        ctx.router.register(
            "/legal/terms-of-service",
            layoutId = "id.neotica.neotica.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.legal.initTermsOfServicePage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_legal_TermsOfServicePage()
        }
        ctx.router.register(
            "/member/",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.member.initMemberPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_member_MemberPage()
        }
        ctx.router.register(
            "/member/{slug}",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.member.initMemberPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_member_MemberDetailPage()
        }
        ctx.router.register(
            "/orpheum",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.orpheum.initOrpheumPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_orpheum_OrpheumPage()
        }
        ctx.router.register(
            "/orpheum/album/{albumId}",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.orpheum.initOrpheumAlbumPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_orpheum_OrpheumAlbumPage()
        }
        ctx.router.register(
            "/photobooth/",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.photobooth.initPhotoboothPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_photobooth_PhotoboothPage()
        }
        ctx.router.register(
            "/profile/ryo-martin",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.profile.initRyoMartinPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_profile_RyoMartinPage()
        }
        ctx.router.register(
            "/projects/",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.projects.initProjectsPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_projects_ProjectsPage()
        }
        ctx.router.register(
            "/projects/ktorreferences",
            layoutId = "id.neotica.neotica.components.layouts.NeoPageLayout",
            initRouteMethod = { ctx ->
                id.neotica.neotica.pages.initKtorReferencesPage(ctx)
            },
        ) { pageCtx -> 
            _id_neotica_neotica_pages_KtorReferencesPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("background-hover", id.neotica.neotica.components.modifiers.BackgroundHoverStyle)
        ctx.theme.registerStyle("background-hover-style-negative", id.neotica.neotica.components.modifiers.BackgroundHoverStyleNegative)
        ctx.theme.registerStyle("background-hover-style-main", id.neotica.neotica.components.modifiers.BackgroundHoverStyleMain)
        ctx.theme.registerStyle("markdown", id.neotica.neotica.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content", id.neotica.neotica.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("headline-text", id.neotica.neotica.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", id.neotica.neotica.SubheadlineTextStyle)
        ctx.theme.registerStyle("feature-card", id.neotica.neotica.pages.holomarket.FeatureCardStyle)
        ctx.theme.registerStyle("submit-panel", id.neotica.neotica.pages.holomarket.SubmitPanelStyle)
        ctx.theme.registerStyle("section-label", id.neotica.neotica.pages.holomarket.SectionLabelStyle)
        ctx.theme.registerStyle("hover-text", id.neotica.neotica.pages.member.HoverText)
        ctx.theme.registerStyle("old-hero-container", id.neotica.neotica.pages.archive.OldHeroContainerStyle)
        ctx.theme.registerVariant("-circle", id.neotica.neotica.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", id.neotica.neotica.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in", id.neotica.neotica.components.sections.header.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("cd-spin", id.neotica.neotica.pages.orpheum.CdSpinKeyframes)
        id.neotica.neotica.initColorMode(ctx)
        id.neotica.neotica.initStyles(ctx)
        id.neotica.neotica.initTheme(ctx)
        id.neotica.neotica.initSiteStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        id.neotica.neotica.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
